import { Dialog } from "@angular/cdk/dialog";
import { CommonModule, NgClass } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

import { IconRegistryService } from "../../services/icon-registry.service";

@Component({
  standalone: true,
  selector: "pax-icon",
  templateUrl: "./icon.html",
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Icon implements OnInit {
  @Input({ required: true })
  name!: string;

  @Input() containerClass: NgClass["ngClass"] = DEFAULT_ICON_CONTAINER_CLASS;

  rawSvgElementHtml: SafeHtml | undefined;

  constructor(
    private readonly _sanitizer: DomSanitizer,
    public readonly _dialog: Dialog,
    private readonly _iconRegistryService: IconRegistryService,
  ) {}

  ngOnInit() {
    const rawSvgIconHtmlUnsafe = this._iconRegistryService.getIcon(this.name);

    this.rawSvgElementHtml =
      this._sanitizer.bypassSecurityTrustHtml(rawSvgIconHtmlUnsafe);
  }
}

export const DEFAULT_ICON_CONTAINER_CLASS: NgClass["ngClass"] =
  "flex content-center flex-wrap w-5 h-5";
